import {makeStyles} from "@material-ui/styles";

export const useBoardStyle = makeStyles((theme) => ({
    table: {
        margin: 'auto',
        borderSpacing: 0,
    },
    row: {
    },
    block: {
        width: '100px',
        height: '100px',
        color: '#607D8B',
        textAlign: 'center',
    }

}), {index: 1})
